module.exports = __webpack_public_path__ + "img/MainTop.e5edf5eb.png";